export default __webpack_public_path__ + "static/media/img-0419-belarus-full-face.ed17ed3c.png";